// extracted by mini-css-extract-plugin
module.exports = {"options_row":"CollectionOptions_options_row__1Ur8t","option_wrapper":"CollectionOptions_option_wrapper__1x1It"};